// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* colors */
  --color-primary-red: #dd1d21;
  --color-primary-light-yellow: #f8cd05;
  --color-primary-green-ethanol: #00854e;
  --color-primary-offwhite: #e2e2e2;
  --color-primary-light-gray: #f5f5f5;
  --color-primary-white: #ffffff;
  --color-secondary-purple: #641964;
  --color-contrast-dark-red: #990000;
  --color-contrast-dark-yellow: #f9b500;
  --color-contrast-dark-green: #005c36;
  --color-contrast-dark-gray: #3b3b3b;
  --color-contrast-gray: #4a4a4a;

  /* shadows */
  --shadow-white: 0px 20px 20px -6px #00000033;
  --shadow-white-light: 0px 5px 5px 0px #0000001a;

  /* typography */
  --font-base: "ShellMedium", sans-serif;
  --font-display-1: "ShellMedium";
  --font-display-2: "ShellMedium";
  --font-headline-1: "ShellHeavy";
  --font-headline-2: "ShellMedium";
  --font-headline-3: "ShellMedium";
  --font-paragraph-1: "ShellBook";
  --font-paragraph-2: "ShellHeavy";
  --font-paragraph-3: "ShellMedium";
  --font-paragraph-4: "ShellBook";

  /* font sizes */
  --font-size-display-1: 48px;
  --font-size-display-2: 32px;
  --font-size-h1: 60px;
  --font-size-h2: 40px;
  --font-size-h2-mobile: 28px;
  --font-size-h3: 32px;
  --font-size-h4: 24px;
  --font-size-h5: 20px;
  --font-size-s1-subtitle: 24px;
  --font-size-s2-subtitle: 24px;
  --font-size-s3-subtitle: 20px;
  --font-size-p1-paragraph: 18px;
  --font-size-p2-paragraph: 18px;
  --font-size-p3-paragraph: 14px;
  --font-size-p4-paragraph: 14px;
  --font-size-d1-disclaimer: 10px;
  --font-size-d2-disclaimer: 14px;

  /* line heights */
  --line-height-display-1: 110%;
  --line-height-display-2: 100%;
  --line-height-h1: 110%;
  --line-height-h2: 140%;
  --line-height-h3: 130%;
  --line-height-h4: 130%;
  --line-height-h5: 120%;
  --line-height-s1-subtitle: 130%;
  --line-height-s2-subtitle: 130%;
  --line-height-s3-subtitle: 130%;
  --line-height-p1-paragraph: 160%;
  --line-height-p2-paragraph: 160%;
  --line-height-p3-paragraph: 140%;
  --line-height-p4-paragraph: 140%;
  --line-height-d1-disclaimer: 130%;
  --line-height-d2-disclaimer: 130%;

  /* letter spacing */
  --letter-spacing-normal: 0%;
  --letter-spacing-headline: -4%;
  --letter-spacing-s2-subtitle: 0%;
  --letter-spacing-paragraph: 0%;
  --letter-spacing-disclaimer: 0%;

  /* grid */
  --grid-max-width: 1280px;
}

html {
  font-family: var(--font-base);
  padding: var(--spacing);
  min-height: 100dvh;
  overflow: hidden;
  overflow-y: auto;
  width: 100dvw;
}

.container {
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 127px;
  justify-content: center;
  width: 100%;
}

.assistive-message--hidden {
  width: 0;
  height: 0;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}

@media (max-width: 768px) {
  .container {
    gap: 75px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/app.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,4BAA4B;EAC5B,qCAAqC;EACrC,sCAAsC;EACtC,iCAAiC;EACjC,mCAAmC;EACnC,8BAA8B;EAC9B,iCAAiC;EACjC,kCAAkC;EAClC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,8BAA8B;;EAE9B,YAAY;EACZ,4CAA4C;EAC5C,+CAA+C;;EAE/C,eAAe;EACf,sCAAsC;EACtC,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gCAAgC;EAChC,gCAAgC;EAChC,+BAA+B;EAC/B,gCAAgC;EAChC,iCAAiC;EACjC,+BAA+B;;EAE/B,eAAe;EACf,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,oBAAoB;EACpB,2BAA2B;EAC3B,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;;EAE/B,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,iCAAiC;EACjC,iCAAiC;;EAEjC,mBAAmB;EACnB,2BAA2B;EAC3B,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;;EAE/B,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,UAAU;EACV,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;EACE;IACE,SAAS;EACX;AACF","sourcesContent":[":root {\n  /* colors */\n  --color-primary-red: #dd1d21;\n  --color-primary-light-yellow: #f8cd05;\n  --color-primary-green-ethanol: #00854e;\n  --color-primary-offwhite: #e2e2e2;\n  --color-primary-light-gray: #f5f5f5;\n  --color-primary-white: #ffffff;\n  --color-secondary-purple: #641964;\n  --color-contrast-dark-red: #990000;\n  --color-contrast-dark-yellow: #f9b500;\n  --color-contrast-dark-green: #005c36;\n  --color-contrast-dark-gray: #3b3b3b;\n  --color-contrast-gray: #4a4a4a;\n\n  /* shadows */\n  --shadow-white: 0px 20px 20px -6px #00000033;\n  --shadow-white-light: 0px 5px 5px 0px #0000001a;\n\n  /* typography */\n  --font-base: \"ShellMedium\", sans-serif;\n  --font-display-1: \"ShellMedium\";\n  --font-display-2: \"ShellMedium\";\n  --font-headline-1: \"ShellHeavy\";\n  --font-headline-2: \"ShellMedium\";\n  --font-headline-3: \"ShellMedium\";\n  --font-paragraph-1: \"ShellBook\";\n  --font-paragraph-2: \"ShellHeavy\";\n  --font-paragraph-3: \"ShellMedium\";\n  --font-paragraph-4: \"ShellBook\";\n\n  /* font sizes */\n  --font-size-display-1: 48px;\n  --font-size-display-2: 32px;\n  --font-size-h1: 60px;\n  --font-size-h2: 40px;\n  --font-size-h2-mobile: 28px;\n  --font-size-h3: 32px;\n  --font-size-h4: 24px;\n  --font-size-h5: 20px;\n  --font-size-s1-subtitle: 24px;\n  --font-size-s2-subtitle: 24px;\n  --font-size-s3-subtitle: 20px;\n  --font-size-p1-paragraph: 18px;\n  --font-size-p2-paragraph: 18px;\n  --font-size-p3-paragraph: 14px;\n  --font-size-p4-paragraph: 14px;\n  --font-size-d1-disclaimer: 10px;\n  --font-size-d2-disclaimer: 14px;\n\n  /* line heights */\n  --line-height-display-1: 110%;\n  --line-height-display-2: 100%;\n  --line-height-h1: 110%;\n  --line-height-h2: 140%;\n  --line-height-h3: 130%;\n  --line-height-h4: 130%;\n  --line-height-h5: 120%;\n  --line-height-s1-subtitle: 130%;\n  --line-height-s2-subtitle: 130%;\n  --line-height-s3-subtitle: 130%;\n  --line-height-p1-paragraph: 160%;\n  --line-height-p2-paragraph: 160%;\n  --line-height-p3-paragraph: 140%;\n  --line-height-p4-paragraph: 140%;\n  --line-height-d1-disclaimer: 130%;\n  --line-height-d2-disclaimer: 130%;\n\n  /* letter spacing */\n  --letter-spacing-normal: 0%;\n  --letter-spacing-headline: -4%;\n  --letter-spacing-s2-subtitle: 0%;\n  --letter-spacing-paragraph: 0%;\n  --letter-spacing-disclaimer: 0%;\n\n  /* grid */\n  --grid-max-width: 1280px;\n}\n\nhtml {\n  font-family: var(--font-base);\n  padding: var(--spacing);\n  min-height: 100dvh;\n  overflow: hidden;\n  overflow-y: auto;\n  width: 100dvw;\n}\n\n.container {\n  max-width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 127px;\n  justify-content: center;\n  width: 100%;\n}\n\n.assistive-message--hidden {\n  width: 0;\n  height: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n}\n\n@media (max-width: 768px) {\n  .container {\n    gap: 75px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
